import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";


export default function UpdateUser() {
  const [data, setData] = useState([]);
  const settings = useSelector((state) => state.settingsdata.settings);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const countries = useSelector((state) => state.countrylistdata.countries);
  const [countryList, setCountryList] = useState();
  const AccessKey = 'U2FsdGVkX19K4mGpmXcIKPAysGxFrCvCqoKSQricQqqRUD/yL2TBWfYWRQpj77uN';

  const {
    addUser,
    editUser,
    deleteUser,
    checkUserExists,
  } = api;



  function checkSubscription(tuid) {
    try {
      if (settings && settings.EnableDriverSubscription) {
        console.log("calling auth subs check");
        var xhttp = new XMLHttpRequest();
        let url =
          "https://bitfy.riss.one/api.php?action=check-subscription&token=" +
          tuid;
        xhttp.onreadystatechange = function () {
          if (this.readyState == 4 && this.status == 200) {
            console.log("this.responseText: ", this.responseText);
            setSubscription(this.responseText, tuid);
          }
        };
        xhttp.open("GET", url, true);
        xhttp.send();
      } else {
        console.log("Not logged in!!!");
      }
    } catch (error) {
      console.log("error: ", error);
    }
  }

  const setSubscription = (responseText, tuid) => {
    try {
      if (settings && settings.EnableDriverSubscription) {
        let response = JSON.parse(responseText);
        console.log("tuid: ", tuid);
        console.log("RESPONSE: ", response);
        //dispatch(updateProfile({ subscribed: response.status, approved: response.status, subscription: response.subscription ? response.subscription : null }));
        dispatch(editUser(tuid, { subscribed: response.status, approved: response.status, subscription: response.subscription ? response.subscription : null }));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  useEffect(() => {
    if (countries) {
      let list = {};
      for (let i = 0; i < countries.length; i++) {
        let obj = countries[i];
        list[obj.country] = obj.country;
      }
      setCountryList(list);
    }
  }, [countries]);

  const fetchSubscriptions = () => {
    var xhttp = new XMLHttpRequest();
    let url =
      "https://bitfy.riss.one/api.php?action=get-subs-list&token=bitfytoken";
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        var r = JSON.parse(this.responseText);
        if (r.status) {
          setData([...r.subscriptions]);
          console.log("r.subscriptions: ", r.subscriptions);
        }
      }
    };
    xhttp.open("GET", url, true);
    xhttp.send();
  };

  useEffect(() => {
    fetchSubscriptions();
    loaded.current = true;
    console.log("userid: ", getParameterByName("userid"));
    console.log("userstatus: ", getParameterByName("userstatus"));
    console.log("staticusers-2: ", staticusers);
    let tempuid = getParameterByName("userid");
    let tempstatus = getParameterByName("userstatus");
    checkUserExists({email: tempuid}).then((res) => {
        console.log("RES: ", res);
        if(res.users && res.users.length > 0) {
            checkSubscription(res.users[0].uid);
        }
    });
  }, []);

  return !loaded.current ? <CircularLoading /> : <div>User Updated!!</div>;
}
